export const campuses = (s) => {
    return s.campuses
}

export const utilities = (s) => {
    return s.utilities
}

export const transits = (s) => {
    return s.transits
}

export default {
    campuses, utilities, transits
}
